import React, { useEffect } from 'react'
import Layout from './layout'

const IveyLuncheon = () => {
    useEffect(() => {
        const initializeZohoForm = () => {
            try {
                const f = document.createElement("iframe");
                f.src = 'https://forms.zohopublic.eu/milkbarco1/form/IveyLuncheon/formperma/XUTbudSxbCLy_dK2aY2qQmvu1aVEMAOxhev0HURTcBo?zf_rszfm=1';
                f.style.border = "none";
                f.style.height = "4867px";
                f.style.width = "100%";
                f.style.transition = "all 0.5s ease";
                f.setAttribute("aria-label", 'Ivey Luncheon');

                const d = document.getElementById("zf_div_XUTbudSxbCLy_dK2aY2qQmvu1aVEMAOxhev0HURTcBo");
                if (d) {
                    // Clear any existing content
                    d.innerHTML = '';
                    d.appendChild(f);
                }

                const handleMessage = (event) => {
                    const evntData = event.data;
                    if (evntData && evntData.constructor === String) {
                        const zf_ifrm_data = evntData.split("|");
                        if (zf_ifrm_data.length === 2 || zf_ifrm_data.length === 3) {
                            const zf_perma = zf_ifrm_data[0];
                            const zf_ifrm_ht_nw = (parseInt(zf_ifrm_data[1], 10) + 15) + "px";
                            const iframe = document.getElementById("zf_div_XUTbudSxbCLy_dK2aY2qQmvu1aVEMAOxhev0HURTcBo")?.getElementsByTagName("iframe")[0];

                            if (iframe && iframe.src.indexOf('formperma') > 0 && iframe.src.indexOf(zf_perma) > 0) {
                                const prevIframeHeight = iframe.style.height;
                                let zf_tout = false;

                                if (zf_ifrm_data.length === 3) {
                                    iframe.scrollIntoView();
                                    zf_tout = true;
                                }

                                if (prevIframeHeight !== zf_ifrm_ht_nw) {
                                    if (zf_tout) {
                                        setTimeout(() => {
                                            iframe.style.height = zf_ifrm_ht_nw;
                                        }, 500);
                                    } else {
                                        iframe.style.height = zf_ifrm_ht_nw;
                                    }
                                }
                            }
                        }
                    }
                };

                window.addEventListener('message', handleMessage, false);

                // Cleanup function
                return () => {
                    window.removeEventListener('message', handleMessage, false);
                };
            } catch (e) {
                console.error('Error initializing Zoho form:', e);
            }
        };

        const cleanup = initializeZohoForm();
        return cleanup;
    }, []);
    return (
        <Layout page={"ivey-luncheon"}>
            <div className="p-6 space-y-6">
                <div className="w-full">
                    <iframe
                        aria-label="Ivey Luncheon"
                        style={{
                            // height: '500px',
                            width: '99%',
                            border: 'none'
                        }}
                        src="Ivey Luncheon"
                        className="rounded-lg"
                    />
                </div>

                {/* Zoho form iframe */}
                <div
                    id="zf_div_XUTbudSxbCLy_dK2aY2qQmvu1aVEMAOxhev0HURTcBo"
                    className="min-h-[500px]"
                />
            </div>


        </Layout>
    )
}

export default IveyLuncheon